import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import CountryList from '../../../components/Data/countries.json';
import BizCardInfo from './BizCardInfo';
import OrganizationInfo from './OrganizationInfo';
import ProfileInfo from './ProfileInfo';

function TabPanel(props) {
	const { children, value, selected, ...other } = props;

	return (
		<Box
			p={3}
			style={{ width: '100%', height: '100%' }}
			role='tabpanel'
			hidden={value !== selected}
			id={`full-width-tabpanel-${selected}`}
			aria-labelledby={`full-width-tab-${selected}`}
			{...other}
		>
			{value === selected && <>{children}</>}
		</Box>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
};

function a11yProps(index) {
	return {
		id: `full-width-tab-${index}`,
		'aria-controls': `full-width-tabpanel-${index}`,
	};
}

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		marginLeft: 24,
	},
	tabRoot: {
		minWidth: 10,
	},
}));

// const options = ['Profile', 'Organization', 'e-Business Card'];
const options = [
	{
		label: 'Profile',
		endpoint: 'profile',
	},
	{
		label: 'Company',
		endpoint: 'org-profile',
	},
	// {
	// 	label: 'e-Business Card',
	// 	endpoint: 'business-card',
	// },
];

export default function General(props) {
	const { subType } = props;
	const classes = useStyles();
	const theme = useTheme();
	const [selected, setSelected] = useState('profile');

	useEffect(() => {
		if (subType) {
			if (options.some((option) => subType === option.endpoint))
				setSelected(subType);
		} else {
			setSelected('profile');
		}
	}, [props]);

	return (
		<>
			<div className={classes.root}>
				<Tabs value={selected} aria-label='full width tabs example'>
					{options.map((option, index) => (
						<Tab
							classes={{ root: classes.tabRoot }}
							key={option.endpoint}
							label={option.label}
							value={option.endpoint}
							component={Link}
							to={'/settings/general/' + option.endpoint}
							{...a11yProps(index)}
						/>
					))}
				</Tabs>
			</div>
			<Divider />

			<Box width='100%' style={{ height: 'inherit', overflowY: 'auto' }}>
				<TabPanel
					value={'profile'}
					index={0}
					selected={selected}
					dir={theme.direction}
				>
					<ProfileInfo />
				</TabPanel>
				<TabPanel
					value={'org-profile'}
					index={1}
					selected={selected}
					dir={theme.direction}
				>
					<OrganizationInfo />
				</TabPanel>
				{/* <TabPanel value={'business-card'} index={2} selected={selected} dir={theme.direction}>
					<BizCardInfo />
				</TabPanel> */}
			</Box>
		</>
	);
}
